// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2rfG_","rightAdornment":"Header_rightAdornment__3kiAZ"};